import { render, staticRenderFns } from "./TaskChoose.vue?vue&type=template&id=02d5461e&scoped=true"
import script from "./TaskChoose.vue?vue&type=script&lang=js"
export * from "./TaskChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5461e",
  null
  
)

export default component.exports